/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MyStay } from '../models/MyStay';
import type { PatientSurveyList } from '../models/PatientSurveyList';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DashboardService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns MyStay
     * @throws ApiError
     */
    public dashboardMyStayRetrieve(): CancelablePromise<MyStay> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/my-stay/',
        });
    }

    /**
     * Patient Survey List
     * Retrieve a list of surveys for a patient.
     * @returns PatientSurveyList
     * @throws ApiError
     */
    public dashboardSurveysList({
        patientId,
    }: {
        /**
         * ID of the patient to filter surveys for. Required for practitioners.
         */
        patientId?: number,
    }): CancelablePromise<Array<PatientSurveyList>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dashboard/surveys/',
            query: {
                'patient_id': patientId,
            },
        });
    }

}
